import { createTheme, responsiveFontSizes } from "@material-ui/core";

// Fonte já importada via index.html ou CSS global
let theme = createTheme({
  palette: {
    primary: {
      main: "#004B82",
      contrastText: "white",
    },
  },
  typography: {
    fontFamily: `'Lexend' , sans-serif`,
  },
});

theme = responsiveFontSizes(theme);

export default theme;
